import Loadable, { NullLoader } from '@comeon/loadable';

const SportsbookLobby = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-lobby" */
			'./lobby/sportsbook-container'
		),
	loading: NullLoader
});

export default SportsbookLobby;
